var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"font-weight-medium grey lighten-3"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"},domProps:{"innerHTML":_vm._s(_vm.quizPageFooter)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }